module.exports = __webpack_public_path__ + "09_mole.d908f456.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/09_mole.png
// module id = wf6X
// module chunks = 0